import { approvalRequest } from "./API";

const ApprovalRequest = async (approvalRequestId, accessToken, action) => {
    try {
        const response = await approvalRequest(approvalRequestId, accessToken, action);
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, data: error.response.data.message };
    }
};

export default ApprovalRequest;
